// state
const state = {
  cruiseRealTimeGis: null,
  cruiseHistoricList: null,
  cruiseLine: null,
  kpisCruise: null,
  kpisCruiseList: null,
  layers: {
    cruiseRealTime: ['fleetRealTime', 'UPDATE_CRUISE_REAL_TIME_GIS']
  }
}

// getters
const getters = {
  getCruiseRealTimeGisData (state) {
    return state.cruiseRealTimeGis
  },
  getCruiseHistoricListData (state) {
    return state.cruiseHistoricList
  },
  getKpisCruise (state) {
    return state.kpisCruise
  },
  getCruiseHistoricLineGisData (state) {
    return state.cruiseLine
  }
}

// actions
const actions = {
  // Update Data Gis
  getCruiseGisData ({ commit, state }, data) {
    const store = this
    if (data !== undefined) {
      state.stationsAirGis = null
      let dataService = {
        method: 'GET',
        endpoint: '/api/dashboard/environmentGis',
        data: null,
        params: {
          type: data[0],
          country: 'ES',
          region: 'ES-GC',
          city: 'ES LPA'
        },
        mutation: data[1]
      }
      store.dispatch('callService', dataService)
    }
  },
  getCruiseHistoricLineGisData ({ commit, state }, data) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/environmentHistoricalGis',
      data: null,
      params: {
        id: data.product,
        type: data.type,
        from1: data.timeStart,
        to1: data.timeEnd,
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_CRUISE_HISTORIC_LINE'
    }
    store.dispatch('callService', dataService)
  },
  getCruiseHistoricListData ({ commit, state }, data) {
    const store = this
    if (data !== undefined) {
      state.stationsAirGis = null
      let dataService = {
        method: 'GET',
        endpoint: '/api/dashboard/environmentHistoricalGis',
        data: null,
        params: {
          type: data.type,
          from1: data.timeStart,
          to1: data.timeEnd,
          country: 'ES',
          region: 'ES-GC',
          city: 'ES LPA'
        },
        mutation: 'UPDATE_CRUISE_HISTORIC_LIST'
      }
      store.dispatch('callService', dataService)
    }
  },
  updateKpisCruise ({ commit, state }, data) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: '/api/kpis/' + data.product + '/' + data.typeProduct,
      data: null,
      params: {
        // product: data.product,
        // typeProduct: data.typeProduct,
        type: data.type,
        city: 'ES LPA',
        from: data.timeStart,
        to: data.timeEnd,
        interval: data.interval,
        intervalUnit: data.intervalUnit
      },
      mutation: 'UPDATE_KPIS_CRUISE'
    }
    store.dispatch('callService', dataService)
  },
  getCruiseRealTimeData ({ commit, state }) {
    const store = this
    // CRUISE REAL TIME UPDATE INTERVAL
    store.dispatch('getCruiseGisData', state.layers.cruiseRealTime)
  }
}

// mutations
const mutations = {
  UPDATE_CRUISE_REAL_TIME_GIS (state, data) {
    state.cruiseRealTimeGis = data
  },
  UPDATE_CRUISE_HISTORIC_LIST (state, data) {
    state.cruiseHistoricList = data
  },
  UPDATE_KPIS_CRUISE (state, data) {
    state.kpisCruise = data
  },
  UPDATE_CRUISE_HISTORIC_LINE (state, data) {
    state.cruiseLine = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardCruise.js